import {useCallback, useSyncExternalStore} from "react";
import type {Subject} from "rxjs";

export function useSubjectSnapshot<T>(subject: Subject<any>, getSnapshot: () => T): T {
    const subscribe = useCallback(
        (onChange: () => void) => {
            const sub = subject.subscribe(onChange);
            return () => sub.unsubscribe();
        },
        [subject]
    );
    return useSyncExternalStore(subscribe, getSnapshot);
}
